"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var JackpotTransferHistoryListCtl = /** @class */ (function (_super) {
    __extends(JackpotTransferHistoryListCtl, _super);
    function JackpotTransferHistoryListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_bonus_jackpot_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_jackpot_id; });
        _this.dk_bonus_jackpot_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_jackpot_title; });
        _this.dk_transfer_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.transfer_amount; });
        _this.dk_transfer_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.transfer_type_code; });
        _this.dk_transfer_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.transfer_type_title; });
        _this.dk_view_balance_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.view_balance_before; });
        _this.dk_money_balance_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.money_balance_before; });
        _this.dk_view_balance_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.view_balance_after; });
        _this.dk_money_balance_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.money_balance_after; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_act_by_usr_admin_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.act_by_usr_admin_id; });
        _this.dk_act_by_usr_admin_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.act_by_usr_admin_login; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this._errDialog = errDialog;
        return _this;
    }
    JackpotTransferHistoryListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    JackpotTransferHistoryListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "jackpot transfer history with id [" + id + "] not found !";
    };
    JackpotTransferHistoryListCtl.prototype.LoadData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListJackpotTransfersByJpIdAndDateRangeGet.exec({
            bonus_jackpot_id: data.jackpotId,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    bonus_jackpot_id: resp.list[i].bonus_jackpot_id,
                    bonus_jackpot_title: resp.list[i].bonus_jackpot_title,
                    act_by_usr_admin_id: resp.list[i].act_by_usr_admin_id,
                    act_by_usr_admin_login: resp.list[i].act_by_usr_admin_login,
                    transfer_amount: resp.list[i].transfer_amount,
                    transfer_type_code: resp.list[i].transfer_type_code,
                    transfer_type_title: resp.list[i].transfer_type_title,
                    view_balance_before: resp.list[i].view_balance_before,
                    money_balance_before: resp.list[i].money_balance_before,
                    view_balance_after: resp.list[i].view_balance_after,
                    money_balance_after: resp.list[i].money_balance_after,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    description: resp.list[i].description
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    JackpotTransferHistoryListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoMakeJackpotTransfer.exec({
            data: {
                bonus_jackpot_id: data.jackpotId,
                jp_amount: data.transferAmount,
                transfer_type_code: data.transferTypeCode,
                description: data.description
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                bonus_jackpot_id: data.jackpotId,
                bonus_jackpot_title: resp.bonus_jackpot_title,
                act_by_usr_admin_id: resp.act_by_usr_admin_id,
                act_by_usr_admin_login: resp.act_by_usr_admin_login,
                transfer_amount: data.transferAmount,
                transfer_type_code: data.transferTypeCode,
                transfer_type_title: resp.transfer_type_title,
                view_balance_before: resp.view_balance_before,
                money_balance_before: resp.money_balance_before,
                view_balance_after: resp.view_balance_after,
                money_balance_after: resp.money_balance_after,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                description: data.description
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return JackpotTransferHistoryListCtl;
}(BaseController_1.BaseController));
exports.JackpotTransferHistoryListCtl = JackpotTransferHistoryListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_jackpots/ctl/JackpotTransferHistoryListCtl.ts
// module id = 977
// module chunks = 0